import * as React from "react";
import * as Text from "@/components/ui/text";

import { cn } from "@repo/common/utils/cn";

/**
 *
 * Card
 *
 */
const _cardBase = cn(
  "rounded-lg bg-white border border-border text-foreground shadow-sm p-6",
);
const _cardFlex = "flex flex-col gap-2";

const Card = ({ className, ...props }: React.ComponentProps<"div">) => (
  <div
    data-slot="card"
    className={cn(_cardBase, _cardFlex, className)}
    {...props}
  />
);
Card.displayName = "Card";

/**
 *
 * Card Header
 * -
 * For use with title + description
 *
 */
const CardHeader = ({ className, ...props }: React.ComponentProps<"div">) => (
  <div
    data-slot="card-header"
    className={cn("flex flex-col space-y-1", className)}
    {...props}
  />
);
CardHeader.displayName = "CardHeader";

/**
 *
 * Card Title
 * -
 * Extends Text.Header
 *
 */
const CardTitle = ({ ...props }: React.ComponentProps<typeof Text.Heading>) => (
  <Text.Heading data-slot="card-title" size="sm" {...props} />
);

/**
 *
 * Card Description
 * -
 * Extends Text.Body
 *
 */
const CardDescription = ({
  ...props
}: React.ComponentProps<typeof Text.Body>) => (
  <Text.Body
    data-slot="card-description"
    className="text-gray-500"
    {...props}
  />
);

/**
 *
 * Card body
 *
 */
const CardBody = ({ className, ...props }: React.ComponentProps<"div">) => (
  <div
    data-slot="card-body"
    className={cn("space-y-1", className)}
    {...props}
  />
);
CardBody.displayName = "Card Body";

const CardContent = ({ className, ...props }: React.ComponentProps<"div">) => (
  <div
    data-slot="card-content"
    className={cn("p-6 pt-0", className)}
    {...props}
  />
);
CardContent.displayName = "CardContent";

const CardFooter = ({ className, ...props }: React.ComponentProps<"div">) => (
  <div
    data-slot="card-footer"
    className={cn("flex items-center p-6 pt-0", className)}
    {...props}
  />
);
CardFooter.displayName = "CardFooter";

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardDescription,
  CardContent,
  CardBody,
};
